export const invoiceStatuses = [
    { value: '', label: 'all' },
    { value: 'pending', label: 'pending' },
    { value: 'paid', label: 'paid' },
    { value: 'canceled', label: 'canceled' },
    { value: 'expired', label: 'expired' },
];

export const transactionStatuses = [
    { value: '', label: 'all' },
    { value: 'approved', label: 'approved' },
    { value: 'pending', label: 'pending' },
    { value: 'failed', label: 'failed' },
];

export const formatMoney = (v) => {
    const n = Number(v || 0);
    return n.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });
};

export const formatDateTime = (v) => {
    if (!v) return '';
    const d = new Date(v);
    if (Number.isNaN(d.getTime())) return v;
    return d.toLocaleString();
};

export const statusBadgeClass = (status) => {
    const s = String(status || '').toLowerCase();

    if (s === 'paid' || s === 'approved') {
        return 'bg-green-100 text-green-700 border-green-200';
    }

    if (s === 'pending') {
        return 'bg-yellow-100 text-yellow-700 border-yellow-200';
    }

    if (s === 'canceled' || s === 'failed') {
        return 'bg-red-100 text-red-700 border-red-200';
    }

    if (s === 'expired') {
        return 'bg-gray-100 text-gray-700 border-gray-200';
    }

    return 'bg-slate-100 text-slate-700 border-slate-200';
};